import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { pullBusinessFunctionForCSR } from "../../actions/globalActions";
import PropTypes from "prop-types";
import { selectNavBarData } from '../../selectors/globalSelectors';
class CSRSpecificDetails extends Component {

	componentDidMount(){
		this.props.requestBusinessFunction({
			metaData: {
				method: "GET",
				url: `/donor-portal/api/user/fetchCSRBusinessFunctions`,
				page: "accountSummary"
			}
		})
	}

	render = () => null
}

CSRSpecificDetails.propTypes = {
    requestBusinessFunction: PropTypes.func
  };

const mapStateToProps = state => {
  return {
	NavBarData: selectNavBarData(state.toJS())
  };
};

export const mapDispatchToProps = dispatch => ({
  requestBusinessFunction: data => dispatch(pullBusinessFunctionForCSR(data))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CSRSpecificDetails)
);
